exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-treeview .form-check[data-v-1ee05f79] {\n  padding-left: 0;\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n          align-items: center;\n}\n.custom-treeview .input-spacer[data-v-1ee05f79] {\n  width: 24px;\n  height: 24px;\n}", ""]);

// exports
